import chatbotRequest from '@/service/channel/http'
import type { RoomAgentsReq, RoomAgentsRes } from '../type/getRoomAgents'

export function getRoomAgentsApi(data: RoomAgentsReq): Promise<RoomAgentsRes> {
    return chatbotRequest<RoomAgentsRes, RoomAgentsReq, RoomAgentsRes>({
        url: '/api/room/agents',
        method: 'post',
        data,
    })
}